import React from 'react';
import './Projects.css';
import ContactCTA from '../../components/ContactCTA/ContactCTA';

const Projects = () => {
  const projects = [
    {
      id: 1,
      title: "FaceMe",
      description: "AI换脸应用，让你体验不同的面孔",
      image: "/images/faceme.png",
      link: "https://play.google.com/store/apps/details?id=com.ai.photoeditor.fx&hl=zh"
    },
    {
      id: 2,
      title: "AgeCam",
      description: "AI年龄相机，探索时光的变迁",
      image: "/images/agecam.png",
      link: "https://play.google.com/store/apps/details?id=com.photo.ai.art.agecam.fx&hl=zh"
    },
    {
      id: 3,
      title: "DressUp",
      description: "AI换装应用，展现不同风格的你",
      image: "/images/dressup.png",
      link: "https://play.google.com/store/apps/details?id=com.aging.ai.toonme&hl=zh"
    },
    {
      id: 4,
      title: "Remagix",
      description: "AI图像处理工具，让照片更出彩",
      image: "/images/remagix.png",
      link: "https://apps.apple.com/gb/app/remagix-ai-clothes-changer/id6612011773"
    },
    {
      id: 5,
      title: "YearCam",
      description: "AI时光相机，记录岁月的痕迹",
      image: "/images/yearcam.png",
      link: "https://play.google.com/store/apps/details?id=com.generator.art.ai&hl=zh"
    }
  ];

  return (
    <div className="projects-page">
      <div className="page-header">
        <h1>Projects</h1>
        <p>探索我的创意项目集</p>
      </div>

      <div className="projects-grid">
        {projects.map(project => (
          <div key={project.id} className="project-card">
            <div className="project-content">
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <a 
                href={project.link} 
                className="project-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                View Project <span>→</span>
              </a>
            </div>
            <div className="project-image">
              <img src={project.image} alt={project.title} />
            </div>
          </div>
        ))}
      </div>

      <ContactCTA />
    </div>
  );
};

export default Projects; 